class FloatingIcon extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("DOMContentLoaded", () => {
      this.init();
    });
  }

  init() {
    const translateYProp = '--tw-translate-y'
    const container = this.closest('swiper-slide');

    //This function sets the start of the scroll animation to the current start of the window + 100vh. It can be called as a callback to another animation, which is perfect.
    const parallaxIcon = (icon) => {
      const curTop = window.scrollY;
      let scrollTl = gsap.timeline({
        scrollTrigger: {
          trigger: "body",
          start: `${curTop} top`,
          end: `${curTop + window.innerHeight} top`,
          scrub: true,
        },
      });

      scrollTl.fromTo(
        icon,
        {
          [translateYProp]: `-50%`,
        },
        {
          [translateYProp]: `0%`,
        },
        0
      );
    };

    const fallInIcon = (icon) => {
      const style = window.getComputedStyle(icon);
      // const matrix = new WebKitCSSMatrix(style.transform);
      // console.log('translateX: ', matrix.m41, matrix.m42);
      return new Promise((resolve, reject) => {
        gsap.fromTo(
          icon,
          {
            opacity: 0,
            [translateYProp]: `-100%`,
          },
          {
            delay: 0.5,
            opacity: 1,
            [translateYProp]: `-50%`,
            duration: 1.2,
            onComplete: resolve,
          }
        );
      });
    };

    const scaleIcon = (icon) => {
      const curTop = window.scrollY;
      let scrollTl = gsap.timeline({
        // scrollTrigger: {
        //   trigger: "body",
        //   start: `${curTop} top`,
        //   end: `${curTop + window.innerHeight} top`,
        //   scrub: true,
        // },
        duration: 1,
        delay: 0.3,
      });

      scrollTl.fromTo(
        icon,
        {
          opacity: 1,
          scale: 0.9,
        },
        {
          opacity: 1,
          scale: 1.3,
        },
        0
      );

      // TODO: This is def the wrong spot for this. We need a separate file for the "hitchcock-effect" screen as a whole. Multiple items in here would blow this up.
      const containerHeader = container?.querySelector('.block-header-region');
      if (containerHeader) {
        scrollTl.fromTo(
          containerHeader,
          {
            y: '50px',
            scale: 1,
          },
          {
            y: 0,
            scale: 0.9,
          },
          0
        );
      }

      const containerFooter = container?.querySelector('.block-footer-region');
      if (containerFooter) {
        scrollTl.fromTo(
          containerFooter,
          {
            y: '-50px',
            scale: 1,
          },
          {
            y: 0,
            scale: 0.9,
          },
          0
        );
      }
    };

    if (container?.classList.contains('hitchcock-effect')) {
      scaleIcon(this);
    }
    else {
      fallInIcon(this).then(() => parallaxIcon(this));
    }
  }
};

if (!customElements.get('floating-icon')) {
  customElements.define('floating-icon', FloatingIcon);
}

